import {
  CreateMaintenanceBannerRequest,
  UpdateMaintenanceBannerRequest,
} from "@shared/zod/schemas/requests/maintenanceBanner"
import { MaintenanceBannerResponse } from "@shared/zod/schemas/responses/maintenanceBanner"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = async (): Promise<MaintenanceBannerResponse[]> => {
  const resp = await axiosAuth({
    url: "/admin/maintenance-banners",
    method: "get",
  })
  return resp.data
}

export const findOne = async (id: string): Promise<MaintenanceBannerResponse> => {
  const resp = await axiosAuth({
    url: `/admin/maintenance-banners/${id}`,
    method: "get",
  })
  return resp.data
}

export const create = async (data: CreateMaintenanceBannerRequest): Promise<MaintenanceBannerResponse> => {
  const resp = await axiosAuth({
    url: "/admin/maintenance-banners",
    method: "post",
    data,
  })
  return resp.data
}

export const update = async (id: string, data: UpdateMaintenanceBannerRequest): Promise<MaintenanceBannerResponse> => {
  const resp = await axiosAuth({
    url: `/admin/maintenance-banners/${id}`,
    method: "patch",
    data,
  })
  return resp.data
}

export const remove = async (id: string): Promise<void> => {
  await axiosAuth({
    url: `/admin/maintenance-banners/${id}`,
    method: "delete",
  })
}

export const toggle = async (id: string): Promise<MaintenanceBannerResponse> => {
  const resp = await axiosAuth({
    url: `/admin/maintenance-banners/${id}/toggle`,
    method: "patch",
  })
  return resp.data
}
